import { render } from "./InterfaceIntegratedEditor.vue?vue&type=template&id=f9f7411a&scoped=true"
import script from "./InterfaceIntegratedEditor.vue?vue&type=script&lang=js"
export * from "./InterfaceIntegratedEditor.vue?vue&type=script&lang=js"

import "./InterfaceIntegratedEditor.vue?vue&type=style&index=0&id=f9f7411a&scoped=true&lang=scss"

import exportComponent from "/tmp/5ea1362f-94e3-43d0-86d7-afc144980eef/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9f7411a"]])

export default __exports__